// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__1gORy","ScrollX":"Scroll_ScrollX__iCuaT","ScrollY":"Scroll_ScrollY__2cUxy"};